 
export const webPortfolio = [
    {
      id: 1,
      title: "Watches App",
      link: 'https://abanoub-pixel.github.io/watches-app/',
      img: 'https://images.unsplash.com/photo-1522312346375-d1a52e2b99b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=394&q=80',
    },
    {
      id: 2,
      title: "Education App",
      link: 'https://abanoub-pixel.github.io/education-website/',
      img: "https://images.unsplash.com/photo-1509062522246-3755977927d7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=932&q=80",
    },
    {
      id: 3,
      title: "Travel Agency App",
      link: 'https://abanoub-pixel.github.io/travel-agency-app/',
      img: "https://images.unsplash.com/photo-1622589222105-3e8af12b48ef?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=388&q=80",
      
    },
      {
      id: 4,
      title: "Realestate App",
      link: 'https://github.com/Abanoub-pixel/realestate-app',
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
  
  ];
  
 
  
 
   
